import { useMemo } from 'react';
import { performanceFactory } from './performanceFactory';
/**
 * Hook providing memoized fwnPerformance instance
 */
export function usePerformance(params) {
    const performance = useMemo(() => (params ? performanceFactory(params) : undefined), [params]);
    return performance;
}
